import {AbstractControl, FormControl} from '@angular/forms';

export class Validation {

  static fiscalNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {

    const nif = control.value.toString().trim(); // just in case...!

    if (control.value) {
      if (nif.length === 9 && Number(nif) !== 0 && nif !== '123456789') {
        const sum =
          nif[7] * 2 +
          nif[6] * 3 +
          nif[5] * 4 +
          nif[4] * 5 +
          nif[3] * 6 +
          nif[2] * 7 +
          nif[1] * 8 +
          nif[0] * 9;
        const mod = sum % 11;

        // tslint:disable-next-line:triple-equals
        if ((mod == 0 || mod == 1) && nif[8] == 0) {
          return null;
          // tslint:disable-next-line:triple-equals
        } else if (nif[8] == 11 - mod) {
          return null;
        }
      }
      return { notValidNif: true };
    } else {
      return null;
    }
  }

  static ibanValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (!control || !control.value) {
      return null;
    }

    const CODE_LENGTHS = {
      NO: 15,
      BE: 16,
      DK: 18,
      FI: 18,
      FO: 18,
      GL: 18,
      NL: 18,
      MK: 19,
      SI: 19,
      AT: 20,
      BA: 20,
      EE: 20,
      KZ: 20,
      LT: 20,
      LU: 20,
      CR: 21,
      CH: 21,
      HR: 21,
      LI: 21,
      LV: 21,
      BG: 22,
      BH: 22,
      DE: 22,
      GB: 22,
      GE: 22,
      IE: 22,
      ME: 22,
      RS: 22,
      AE: 23,
      GI: 23,
      IL: 23,
      AD: 24,
      CZ: 24,
      ES: 24,
      MD: 24,
      PK: 24,
      RO: 24,
      SA: 24,
      SE: 24,
      SK: 24,
      VG: 24,
      TN: 24,
      PT: 25,
      IS: 26,
      TR: 26,
      FR: 27,
      GR: 27,
      IT: 27,
      MC: 27,
      MR: 27,
      SM: 27,
      AL: 28,
      AZ: 28,
      CY: 28,
      DO: 28,
      GT: 28,
      HU: 28,
      LB: 28,
      PL: 28,
      BR: 29,
      PS: 29,
      KW: 30,
      MU: 30,
      MT: 31
    };

    const input = control.value.toString().trim();
    if (input === '' || input === undefined) {
      return null;
    }

    const iban = input.toUpperCase().replace(/[^A-Z0-9]/g, ''),
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
    let digits;

    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return { notValidIban: true };
    } else {
      digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (
        letter
      ) => {
        return letter.charCodeAt(0) - 55;
      });

      let checksum = digits.slice(0, 2),
        fragment;

      for (let offset = 2; offset < digits.length; offset += 7) {
        fragment = checksum + digits.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
      }

      return checksum === 1 ? null : { notValidIban: true };
    }
  }

  static nameValidator(control: FormControl): { [s: string]: boolean } {
    // '^[a-zA-Z-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ']+$'
    if (
      !control.value.match('^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ \']+$') &&
      control.value !== ''
    ) {
      return { invalidName: true };
    }
    return null;
  }

  static creditCardNameValidator(
    control: FormControl
  ): { [s: string]: boolean } {
    if (!control.value.match('^[a-zA-Z ,.\'-]+$')) {
      return { invalidName: true };
    }
  }

  static addressValidator(control: FormControl): { [s: string]: boolean } {
    if (
      !control.value.match(
        '^[a-zA-Z-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ,.\'-ºª]+$'
      )
    ) {
      return { invalidName: true };
    }
    return null;
  }

  static phoneValidator(control: FormControl): { [s: string]: boolean } {
    if (control.value === '') {
      return null;
    }
    if (!control.value.match('^(\\+351|00351|351)?[2|9][0-9]{8}$')) {
      return { invalidPhone: true };
    }
    return null;
  }

  static zipcodeValidator(control: FormControl): { [s: string]: boolean } {
    if (!control.value.match('\\d{4}-\\d{3}') && control.value !== '') {
      return { invalidPostalCode: true };
    }
    return null;
  }

  static doorNumberValidator(control: FormControl): { [s: string]: boolean } {
    if (control.value === 0) {
      return {invalidDoorNumber: true};
    }
    return null;
  }

  static confirmPasswordValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const password = control.get('password').value;
    const confirmPassword = control.get('confirmPassword').value;
    if (password === '' || confirmPassword === '') {
      return { required: true };
    } else if (password !== confirmPassword) {
      return { invalidPass: true };
    } else {
      return null;
    }
  }

  static creditCardNumberValidator(value) {
    const result =
      value
        .split('')
        .reverse()
        .map(x => parseInt(x, null))
        .map((x, idx) => (idx % 2 ? x * 2 : x))
        .map(x => (x > 9 ? (x % 10) + 1 : x))
        .reduce((accum, x) => (accum += x)) %
        10 ===
      0;

    if (result === true) {
      return null;
    } else {
      return true;
    }
  }
}
